import { RouterPaths } from '@/presentation/router/RouterPathsMapper'

const adhpInfoTabs = ['rotaer', 'infotemp', 'notam', 'metar', 'taf', 'aipsup'] as const

export type AdhpInfoTab = (typeof adhpInfoTabs)[number]
export const ADHP_INFO_LEGACY_PERSISTENCE_KEY = 'adhp-info:last-state'

export interface GetAdhpInfoPathParams {
  code?: string
  tab?: AdhpInfoTab
}

export interface AdhpInfoSearchParams {
  code?: string
  tab: AdhpInfoTab
}

export const DEFAULT_ADHP_INFO_TAB: AdhpInfoTab = 'rotaer'
let volatileAdhpInfoSearchParams: Partial<AdhpInfoSearchParams> | undefined

export function isAdhpInfoTab(value: string | null): value is AdhpInfoTab {
  return value !== null && adhpInfoTabs.includes(value as AdhpInfoTab)
}

function normalizeCode(code?: string | null): string | undefined {
  const trimmedCode = code?.trim()
  return trimmedCode ? trimmedCode.toUpperCase() : undefined
}

export function getAdhpInfoPath(params: GetAdhpInfoPathParams = {}): string {
  const searchParams = new URLSearchParams()
  const code = normalizeCode(params.code)

  if (code) {
    searchParams.set('code', code)
  }

  if (params.tab) {
    searchParams.set('tab', params.tab)
  }

  const queryString = searchParams.toString()

  return queryString ? `${RouterPaths.ADHP_INFO}?${queryString}` : RouterPaths.ADHP_INFO
}

export function getLastAdhpInfoSearchParams(): Partial<AdhpInfoSearchParams> | undefined {
  return volatileAdhpInfoSearchParams
}

export function setLastAdhpInfoSearchParams(params: Partial<AdhpInfoSearchParams>): void {
  const code = normalizeCode(params.code)
  const tab = isAdhpInfoTab(params.tab ?? null) ? params.tab : undefined

  volatileAdhpInfoSearchParams = {
    code,
    tab
  }
}

export function clearLastAdhpInfoSearchParams(): void {
  volatileAdhpInfoSearchParams = undefined
}

export function parseAdhpInfoSearchParams(
  search: string,
  fallbackParams?: Partial<AdhpInfoSearchParams>
): AdhpInfoSearchParams {
  const searchParams = new URLSearchParams(search)
  const code = normalizeCode(searchParams.get('code')) ?? normalizeCode(fallbackParams?.code)
  const rawTab = searchParams.get('tab')
  const fallbackTab = isAdhpInfoTab(fallbackParams?.tab ?? null) ? fallbackParams.tab : DEFAULT_ADHP_INFO_TAB

  return {
    code,
    tab: isAdhpInfoTab(rawTab) ? rawTab : fallbackTab
  }
}
